// extracted by mini-css-extract-plugin
export default {"wrapper":"Sell_wrapper__gDabp","content":"Sell_content__c2ujW","text":"Sell_text__V-Xe6","title":"Sell_title__lCEug","button":"Sell_button__E1Dyy"};